import React, { Fragment, useContext, useEffect } from 'react';
import { Link } from 'gatsby';
import { EventContext } from '../../contexts/eventContext';
import { SponsorContext } from '../../contexts/sponsorContext';
import Loader from '../loader';
import arrow_back from '../../images/arrow_back.png';
import defaultImage from '../../images/image_default.jpg';

const EventItemPage = ({ eventid }) => {
	const { eventItem, eventItemError, eventItemLoading, getEventItem } = useContext(EventContext);

	const {
		smallSponsors, mediumSponsors, largeSponsors,
		sponsors, sponsorsError, sponsorsLoading, getSponsors
	} = useContext(SponsorContext);

	useEffect(() => {
    getSponsors();
	}, []);

	useEffect(() => {
		getEventItem(eventid);
	}, [eventid]);

	if (eventItemLoading || (!eventItemLoading && !eventItemError && !eventItem)) {
		return (
			<div style={{marginTop: 100, marginBottom: 100 }}>
				<Loader />
			</div>
		)
	}

	if (eventItemError) {
		return <h1>Er ging iets fout bij het laden..</h1>;
	}

	return (
		<div className="container clear">
			<section className="content_left">
				<div className="clear">
					<h1>{eventItem.title}</h1>
					<Link to="/evenementen">
						<span>
							<img src={arrow_back} />
							Naar overzicht
						</span>
					</Link>
				</div>
				<div className="single_content">
					<img alt={eventItem.title} src={eventItem.image ? eventItem.image.replace('public/images', 'public/images_resized') :  defaultImage} />
					<div>
						<h2>
							{`
							${new Date(eventItem.dateTime).getDate()}-${new Date(eventItem.dateTime).getMonth() + 1}-${new Date(
								eventItem.dateTime
							).getFullYear()}
							`}
						</h2>
						<div dangerouslySetInnerHTML={{ __html: eventItem.text.replace(/public\/images/g, 'public/images_resized') }} />
						{/* <div dangerouslySetInnerHTML={{ __html: eventItem.text }} /> */}
					</div>
				</div>
			</section>
			<section className="sidebar">
				<section className="sponsor">
					<h1>Sponsoren</h1>
					{ !sponsorsError &&
						!sponsorsLoading &&
						sponsors && (
							<Fragment>
							<ul>
								{mediumSponsors.slice(0, 2).map((sponsor) => (
									<li key={sponsor._id} className="medium">
										<a target="_blank" href={sponsor.url}>
											<img src={sponsor.image} alt={sponsor.name} />
										</a>
									</li>
								))}
							</ul><ul>
								{largeSponsors.slice(0, 2).map((sponsor) => (
									<li key={sponsor._id} className="medium">
										<a target="_blank" href={sponsor.url}>
											<img src={sponsor.image} alt={sponsor.name} />
										</a>
									</li>
								))}
							</ul><ul>
								{smallSponsors.slice(0, 2).map((sponsor) => (
									<li key={sponsor._id} className="small">
										<a target="_blank" href={sponsor.url}>
											<img src={sponsor.image} alt={sponsor.name} />
										</a>
									</li>
								))}
								<li className="small advert">
									<a target="_blank" href="mailto:info@hitstreamfm.nl">Uw logo hier?</a>
								</li>
							</ul>
						</Fragment>
					)}
				</section>
			</section>
		</div>
	);
};
export default EventItemPage;
